<template>
  <div class="container lms-wrapper-two">

    <researcher-nav />

    <div class="lms-content" @click="closeLevel2()">
      <stf-header class="filled" ref="lmsv4header" />

      <div class="lms-content-body" style="height: calc(100vh - 80px); overflow: auto">
        
        <div class="bg-white mg-20 rounded-20 pd-20" >

          <div class="row">
            <div class="col-4 d-none">





            <div class="pd-b-10">
              <label class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10">Төслийн мэдээлэл</label>
              <nav class="nav nav-sidebar tx-13">
                <a v-for="(b, i) in task.b" role="button" :key="i" @click="taskActiveMenu=b.id" :class="`nav-link ${b.id==taskActiveMenu?'active':''} `">
                  <feather type="folder" style="height: 16px !important; width: 16px !important" class="mg-r-5"></feather>
                  <span>{{ b.nm }}</span>
                </a>
              </nav>
            </div>


            </div>
            <div class="col-12">
              <div>


                <div v-for="(b, i) in task.b" :key="i">
            <div class="card mg-b-20 mg-lg-b-25">
              <div
                class=" card-header bg-light pd-y-15 pd-x-20 d-flex align-items-center justify-content-between"
              >
                <h6 class="tx-uppercase tx-semibold mg-b-0">
                  {{ i + 1 }}. {{ b.nm }}
                </h6>
                <nav class="nav nav-with-icon tx-13 mg-l-20">
                  <!-- style="min-width: 240px" -->
                  <!-- <a @click="openAdd(b)" class="nav-link" role="button"><feather type="edit" class="mg-r-5 ht-20-f wd-20-f"></feather> Засах</a>
                  <a @click="openAdd(b)" class="nav-link" role="button"><feather type="trash-2" class="mg-r-5 ht-20-f wd-20-f"></feather> Устгах</a>-->
                  <!-- <a v-if="i==0" @click="openTaskEdit(task)" class="nav-link" role="button">
                    <feather
                      type="edit"
                      class="mg-r-5 ht-20-f wd-20-f"
                    ></feather
                    >Үндсэн мэдээлэл шинэчлэх

                  </a> -->
                  <a v-if="i>0 && b.ot!=6" @click="openAdd(b)" class="nav-link" role="button">
                    <feather
                      type="plus"
                      class="mg-r-5 ht-20-f wd-20-f"
                    ></feather
                    >Нэмэх
                  </a>
                </nav>
              </div>
              <!-- card-header -->
              <div class="card-body pd-10" v-if="i==0">
                
                  <div class="d-flex">
                    <task-info class="wd-50p"
                      :fields="fields"
                      :obj="{ data: { task: task }}"
                      :loaded="fetched"
                      :boxId="0"
                      :parentTask="null"
                      
                      
                    />
                    <div class="bd-l bd-2 pd-l-10 wd-50p d-flex align-items-center justify-content-between">
                      <div>
                        <div class="alert alert-warning mg-b-20" role="alert">
                          <h6 class="alert-heading">Санамж !</h6>
                          <p>Гадаадад сурах хүсэлтэй оюутан сурагчдад бүрдүүлэх материал шаардагдах бичиг баримт.</p>
                          <!-- <hr> -->
                          <!-- <p class="mb-0">Материал хүлээн авах сүүлийн хугацаа: <b>{{ adTask.d2 | moment('YYYY.MM.DD-ны HH:mm') }}</b></p> -->
                        </div>

                        <ul class="list-group wd-100p">
                          <li v-for="(b,bi) in task.b.filter(x=>x.id!=0)" :key="bi" class="list-group-item wd-100p d-flex align-items-center">
                            <feather type="menu" class="mg-r-10 ht-20-f wd-20-f text-muted-xl"></feather>
                            {{ b.nm }}
                            <div class="text-white badge badge-primary mg-l-auto tx-14">{{ b.taskCount }}</div>
                            <!-- {{ b.ot }} -->
                          </li>
                        </ul>
                        
                      </div>
                      <!-- <div >{{ b.nm }}</div> -->
                    </div>
                  </div>
              </div>
              <div class="card-body bx-embed-outer pos-relative pd-0" v-else>
                <loader
                  :ref="`ldr_box_${b.id}`"
                  :box="b"
                  :prms="{ boxChooser: false }"
                  :detailSettingProp="{
                    boxSetting: {
                      listSetting: { height: 0 },
                      hideToolbar: true,
                      hideEmptyTemplate: true,
                      autoHeight: true,
                      hideFooter: true
                    },
                  }"
                  @on-attach="showFile($event)"
                  @on-detail="showDetail"
                  @load-box="loadBoxData"
                />
                <!-- @on-detail="showDetail"
                  @load-box="loadBoxData" -->
                <!-- @show-edit="editShow($event)"
                            @box-edit="editBox"
                            @box-delete="deleteBoxConfirm"
                            @on-detail="showDetail"
                            @on-attach="showFile($event)"
                            @load-box="loadBoxData"
                            @update-box-count="b.attachCount = $event.count; b.formCount = $event.count;"
                            @box-loaded="boxLoading=false;"
                            @on-reload-parent="init($event)"
                @on-exam-report="onExamReport"-->
              </div>
              <!-- card-footer -->
            </div>
          </div>
              </div>
            </div>
          </div>
          
          <div class="d-flex wd-100p">
            <button @click="$router.go(-1)" class="btn btn-light">Буцах</button>
            
            <div v-if="task.i8 > 0" class="mg-l-auto">
              <div class="alert alert-info" role="alert">
                <!-- <h6 class="alert-heading">Төлөв</h6> -->
                <p style="margin-bottom: 0">Мэдээлэл БЗС-д илгээгдсэн.</p>
              </div>
            </div>
            <div v-else class="mg-l-auto">
              <button @click="saveFake" class="text-white btn btn-warning wd-200">Хадгалах</button>
              <button @click="saveRealBefore" class="text-white btn btn-success mg-l-20 wd-200">Илгээх</button>
            </div>
          </div>
        </div>
      </div>


    </div>

    <div>



    </div>

    <task-edit
                  wd="55%"
                  :prms.sync="taskEdit"
                  :show.sync="taskEdit.show"
                  :disablePreEditCheck="true"
                  @on-task-posted="taskPosted"
                @on-edit-close="editClosed"
                ></task-edit>

    <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      propWidth="50%"
      @on-task-detail="showDetail"
      @on-task-delete="taskDeleted"
      @on-task-reload="taskUpdated"
      @on-task-close="taskDialogSide.id = 0"
      :detailSettingProp="{
        hideMainMenu: true,
        showMiniMenu: true,
        hideExecution: true,
        hideProcess: true,
      }"
    ></task-detail-side>

    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <b-modal v-model="gereeObj.modal" size="xl" scrollable hide-header-close
    title="Гэрээг зөвшөөрснөөр үргэлжлүүлэх боломжтой" no-close-on-backdrop>
      <file-preview
        :minusHeight="400"
        :show="gereeObj.modal"
        :id.sync="gereeObj.attachId"
        @on-hide="gereeObj.modal = false"
        :force="true"
      />
      <template #modal-footer>
        <div class="ml-auto d-flex align-items-center">
          <div class="mr-2">
            <input v-model="gereeObj.verified" type="checkbox" />
          </div>
          <b-button
            variant="primary"
            size="sm"
            @click="verifyGeree()"
          >
            Зөвшөөрөх
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import loader from "@/components/box/loader/loader.vue";

import { request } from "@/api/all";
import { getDetailFields } from "@/api/taskCore";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Drawer } from "element-ui";

export default {
  components: {
    vueCustomScrollbar, loader, Drawer,

    researcherNav: () => ({
      component: import("@/views/home/apps/elf/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    stfHeader: () => ({
      component: import("@/views/home/apps/elf/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),

    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskInfo: () => ({
      component: import("@/components/task/detail/ot/components/info.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      gereeObj: {
        attachId: null,
        modal: false,
        verified: false,
      },
      drawerDta: true,
      task: {
        b:[]
      },
      profile: {
        b:[]
      },
      taskActiveMenu: 0,
      taskModel: {},
      taskRdy: false,
      prjId: null,
      prjOt: null,
      taskEdit: {
        id: 0,
        boxId: 0,
        show: false,
        render: false,
        objectTypeId: 0,
        projectId: 0,
        parentId: 0,
        fillAfter:{
          organizationTaskId: null
        }
      },

      fields: [],
      fetched: false,
      taskDialogSide: {
        show: false,
        id: 0,
        boxId: 0,
        key: 0,
      },
      fileDialog: {
        show: false,
        id: 0
      },
      befcr: 0,
      adTask:{
        d2: null,
      },
      adName: '',
      adVal: '',
      servertime: null,
    };
  },
  mounted() {    
    this.init(this.$route.params.id);
    // let prj = this.$store.state.app.groupDefaultProjects.filter(
    //   (x) => x.objectTypeId == parseInt(569, 10)
    // );

    // if (prj.length > 0) {
    //   this.prjId = prj[0].id;
    //   this.prjOt = prj[0].objectTypeId;
    // }

    // request({
    //   api: { method: "POST", url: "taskCore/GetCoreList" },
    //   data: {
    //     skip: 0,
    //     size: 50,
    //     projectId: this.prjId,
    //     //ot: this.prjOt,
    //     model: {
    //       organizationTaskId: this.$route.params.id
    //     }
    //   },
    //   store: this.$store,
    // }).then((res) => {
    //   if (res != false) {
    //     if(res.data.allCount>0){
    //       request({
    //         api: { method: "get", url: "task/info" },
    //         params: { id: this.$route.params.id },
    //         store: this.$store,
    //       }).then((resi) => {
    //         if (res != false) {
    //           //console.log('resi', resi);
    //           this.adTask= resi.data.task;

    //           this.befcr= 2;
    //           this.initAfter(res.data.tasks[0]['id']);
    //         }
    //       });

    //     }else{
    //       request({
    //         api: { method: "get", url: "task/info" },
    //         params: { id: this.$route.params.id },
    //         store: this.$store,
    //       }).then((resi) => {
    //         if (res != false) {
    //           //console.log('resi', resi);
    //           this.adTask= resi.data.task;
    //           this.adName= resi.data.task.task;
    //           this.befcr= 1;
    //         }
    //       });
    //       //this.initAfter(0);
    //     }
    //     //console.log('step -1', res);
    //   }
    // });
    
    //this.initAfter(0);

    // request({
    //     api: { method: "GET", url: "task/taskInheritedDetail" },
    //     params: { id: 3429418 },
    //     store: this.$store,
    //   }).then((res) => {
    //     this.profile = res.data.task;
    //   }
    //   );
  },
  methods: {
    logout() {
      this.$refs.lmsv4header.logout();
    },
    searchHandler() {
      //console.log('srch handled');
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
      //console.log(shown, this.navbarMode);
    },
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init(id) {
      request({
        // api: { method: "POST", url: "v2/learn/studentHomeData" },
        api: { method: "GET", url: "task/TaskInheritedDetail" },
        params: { id: id },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.task = res.data.task;
          //console.log('res.data.task', res.data.task.organizationTask.locTypeId);
          this.task.b.unshift({id: 0, nm: 'Ерөнхий мэдээлэл'});

          this.initFields(this.task.objectTypeId);
          //console.log('step 1', res.data.task.organizationTask.locTypeId);
          this.initUrilgaLocType(res.data.task);

          //this.openTaskEdit(this.task);
          

          //this.initAfter(this.task.id, 561);
        }
      });
    },
    verifyGeree(){
      if(this.gereeObj.verified){
        let _pstTsk= null;
        request({
          api: { method: "GET", url: "Task/GetInherited" },
          params: {
            id: this.task.id,
            objectTypeId: this.task.objectTypeId,
            projectId: this.task.projectId,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            _pstTsk= res.data.task;
            _pstTsk.isRepeat= true;

            request({
              api: { method: "POST", url: "Task/PostInherited" },
              data: { model: _pstTsk },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                this.gereeObj.modal= false;
                Notification.success({
                  title: "Gмжилттай",
                  message: `Гэрээг зөвшөөрлөө`,
                  duration: 5000,
                  position: "bottom-right",
                });
              }
            });
          }
        });
      }else {
        Notification.warning({
          title: "Мэдэгдэл",
          message: `Гэрээг зөвшөөрөөгүй байна !`,
          duration: 5000,
          position: "bottom-right",
        });
      }
    },
    showGeree(gereeId){
      this.gereeObj.attachId= gereeId;
      this.gereeObj.modal= true;
    },
    initUrilgaLocType(task){
      //console.log('step 2');
      let _ltid= task.organizationTask.locTypeId;
      request({
        api: { method: "get", url: "Type/GetInheritedDetail" },
        params: { id: _ltid, parentId: 0, key: null },
        store: this.$store
      }).then(res => {
        if (res != false) {
          // console.log('re', res);
          if(res.data.attachId>0 && task.isRepeat===false){
            this.showGeree(res.data.attachId);
          }
          this.initUrilgaLocTypeParent(res.data.parentId);
          // this.locTypeModel = res.data;
          // if (id == 0 && this.flag == 600) {
          //   this.locTypeModel.field1 = "600";
          // }
        }
      });
    },
    initUrilgaLocTypeParent(ltpid){
      //console.log('step 3');
      request({
        api: { method: "get", url: "Type/GetInheritedDetail" },
        params: { id: ltpid, parentId: 0, key: null },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('re', res);
          if(res.data.code=='scholarship'){
            this.task.b= this.task.b.filter(x=>x.ot!=576);
            //console.log('this.task.b', this.task.b);
          }
          // this.locTypeModel = res.data;
          // if (id == 0 && this.flag == 600) {
          //   this.locTypeModel.field1 = "600";
          // }
        }
      });
    },
    openTaskEdit(task){
      this.taskEdit.id = task.id;
      this.taskEdit.objectTypeId = task.objectTypeId;
      this.taskEdit.projectId = task.projectId;
      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    openAdd(b) {
      //console.log(b);
      this.taskEdit.id = 0;
      this.taskEdit.boxId = b.id;
      this.taskEdit.objectTypeId = b.ot;
      this.taskEdit.projectId = b.projectId;
      this.taskEdit.fillAfter.organizationTaskId = this.task.id;

      this.taskEdit.parentTask = this.task;
      this.taskEdit.parentId = this.task.id;

      //this.taskEdit.parentId = this.profile.id;
      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    initFields(ot) {
      getDetailFields({ params: { objectTypeId: ot } }).then((res) => {
        if (res != false) {
          this.fields = res.data.fields;
          this.fetched = true;
        }
      });
    },
    taskPosted(e) {
      //console.log('taskPosted', e);
      //this.$refs[`ldr_box_${e.prms.boxId}`][0].init();
      this.$refs[`ldr_box_${e.prms.boxId}`][0].reInit();
      this.editClosed();
    },
    editClosed() {
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    initAfter(id){
      

      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: id,
          objectTypeId: this.prjOt,
          parentId: 0,
          projectId: this.prjId,
          boxId: 0,
          userId: this.$store.state.user.userInfo.userId,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.taskRdy= true;
          this.taskModel= res.data.task;
          if(id==0){
            this.taskModel.task= this.adVal;
            //this.taskModel.task= this.$store.state.user.userInfo.fullName;
            this.taskModel.organizationTaskId= this.$route.params.id;
            //console.log('step 0', this.$store.state.user.userInfo.fullName);
            this.saveDta();
          }else{
            this.init(res.data.task.id);
            //console.log('step 1', res);
          }
        }
      });
    },
    saveDta() {
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.taskModel },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.befcr=2;
          this.init(res.taskId);
          //console.log('step 2', res);
        }
      });
    },
    showDetail(e) {
      //console.log('showDetail', e);
      this.taskDialogSide.boxId = e.boxId;
      this.taskDialogSide.id = e.id;
    },
    loadBoxData(e) {
      //console.log('loadBoxData', e);
    },
    taskDeleted() {
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
      this.editClosed();
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    taskUpdated(e){
      this.taskDialogSide.id = 0;
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
      //console.log('taskUpdated', e);
    },
    saveFake(){
      Notification.warning({
        title: "Мэдээлэл хадгалагдлаа",
        //message: `${moment(this.adTask.d2).format("yyyy.MM.DD HH:mm") }-с өмнө ШУТСАН-д илгээх шаардлагатайг анхаарна ууs`,
        duration: 30000,
        position: "bottom-right",
      });
    },
    saveRealBefore(){
      request({
        api: { method: "GET", url: "servertime" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.servertime= res.data.now;
          this.saveReal();
        }
      });
    },
    saveReal(){
      let errs=[];

      // if (moment(this.adTask.d2).isBefore(moment(this.servertime))) {
      //   errs.push('Хүсэлт авах хугацаа өнгөрсөн байна');
      // }

      

      if(errs.length>0){
        Notification.warning({
          title: "",
          message: `${ errs[0] }`,
          duration: 30000,
          position: "bottom-right",
        });
      }else{
        //# ot 569
        let _pstTsk= null;
        request({
          api: { method: "GET", url: "Task/GetInherited" },
          params: {
            id: this.task.id,
            objectTypeId: this.task.objectTypeId,
            //parentId: 0,
            projectId: this.task.projectId,
            //boxId: 0,
            //userId: this.$store.state.user.userInfo.userId,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            _pstTsk= res.data.task;
            _pstTsk.i8= 1;

            request({
              api: { method: "POST", url: "Task/PostInherited" },
              data: { model: _pstTsk },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                this.$router.push({name: 'elfStudent'});
                Notification.success({
                  title: "амжилттай",
                  message: `мэдээлэл илгээлээ`,
                  duration: 5000,
                  position: "bottom-right",
                });
              }
            });
          }
        });
        
        //console.log('this.taskModel.objectTypeId', this.taskModel, this.task);
        // request({
        //   api: { method: "POST", url: "Task/PostInherited" },
        //   data: { model: this.taskModel },
        //   store: this.$store,
        // }).then((res) => {
        //   if (res != false) {
        //     this.befcr=2;
        //     this.init(res.taskId);
        //     //console.log('step 2', res);
        //   }
        // });
        // Notification.warning({
        //   title: "",
        //   message: `${ errs[0] }`,
        //   duration: 30000,
        //   position: "bottom-right",
        // });
      }
    },
  },
};
</script>
<style lang="less">
.bx-embed-outer{
  .filemgr-content-body{
    position: relative;
    .pd-x-10{
      height: auto !important;
    }
  }
}
</style>